import React, { useEffect, useRef } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import './App.css';
import AllRoutes from './routers';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { store } from './store/store';
import { createSocket } from './pages/Role/socket';
import { updatePermissionsInState } from './store/slices/authSlice';

function App() {
  const socketRef = useRef(null);
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.auth?.after_login_data?.data)
  useEffect(() => {
      if (!user?._id) return;

      socketRef.current = createSocket(user._id);
      console.log('as', socketRef.current)
      socketRef.current.on("connect", () => {
        // ✅ send userId after connect
        socketRef.current.emit("register", user._id);
    });

      socketRef.current.on("role updated", async (data) => {
          const updatedData = {
            permissionIds: data?.permissions,
            _id: data?.roleId,
            role_name: data?.role_name
          }
          await dispatch(updatePermissionsInState(updatedData));
      });

      return () => {
          if (socketRef.current) {
              socketRef.current.off("role updated");
              socketRef.current.disconnect();
          }
      };
  }, [user?._id]);
  return (
    <BrowserRouter basename="/">
      <Provider store={store}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#B49630',
              colorBgContainer: '#ffffff',
              colorBgLayout: '#ffffff',
            },
            components: {
              Layout: {
                bodyBg: '#ffffff',
                headerBg: '#ffffff',
                siderBg: '#2C323A',
              },
              Menu: {
                darkItemBg: '#2C323A',
                darkSubMenuItemBg: '#1f2429',
                darkItemSelectedBg: '#B49630',
                darkItemHoverBg: '#3a4149',
              },
            },
          }}
        >
          <AllRoutes />
          {/* <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route
                path="/*"
                element={
                  <AdminLayout>
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/settings" element={<Settings />} />
                    </Routes>
                  </AdminLayout>
                }
              />
            </Routes>
          </Router> */}
        </ConfigProvider>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
